import type { QuotaStates } from 'server/types/context/IUser';

/**
 * Enum сделан на основе типов из profile-service
 * @link https://gitlab.corp.mail.ru/cloud/go/profile-service/-/blob/master/internal/app/api/v1/user/full.go?ref_type=heads#L29
 */
export const enum ProfileFlags {
    EMAIL_CONFIRMING = 'EMAIL_CONFIRMING',
    EMAIL_CONFIRMED = 'EMAIL_CONFIRMED',
    SINGLE_QUOTA = 'SINGLE_QUOTA',
    MARKED_FOR_DELETE = 'MARKED_FOR_DELETE',
    VIGBO_LINKED = 'VIGBO_LINKED',
}

export interface ProfileOverquota {
    state?: QuotaStates;
    clearTime?: number;
    blockTime?: number;
    clearStarted?: number;
    trashSize?: number;
    status?: 'loaded' | 'request' | 'failed' | null;
    startPipeline?: number;
    cycleCount?: number;
}

interface Device {
    ctime: number;
    flags: Record<string, unknown>;
    name: string;
    platform: 'iOS' | 'Web' | 'DiskO' | 'Android';
    utime: number;
}

export interface Profile {
    email: string;
    overquota?: ProfileOverquota;
    checkUpdateLicenseCompleted: boolean;
    version?: string;
    devices?: Record<string, Device>;
    ctime: number;
    cycleCount?: number;
    isLoading: boolean;
    isLoaded: boolean;
    flags: ProfileFlags[];
}

export interface ApiProfile {
    email: string;
    properties: { 'overquota.clear_time'?: number; 'overquota.clear_started'?: number };
}

export enum ProfileApiResponses {
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
    BAD_REQUEST = 'BAD_REQUEST',
}
